import React from 'react'
import noAgreements from 'assets/Images/no-agreements.svg'

const NoAgreements: React.FC = () => {
  return (
    <div className="flex flex-col justify-center align-center py-40px px-40px">
      <div className="w-10rem h-10rem">
        <img src={noAgreements} alt="no-agreements" />
      </div>
      <h3 className="text-18 w-600 mt-15px">No Agreements</h3>
      <p className="text-center mt-15px">
        Create agreement for this event that should be accepted by every perent
        before they register to event.
      </p>
    </div>
  )
}

export default NoAgreements
